import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

import crossBlack from "../../assets/images/onboardingImages/crossBlack.svg";
import longArrow from "../../assets/images/onboardingImages/longArrow.svg";
import VerifyMyTradePayment from "../VerifyMyTradePayment";
import { useDispatch, useSelector } from "react-redux";
import {
  resetOnBoardingStartContext,
  storeUser,
} from "../../redux/users/usersSlice";
import { showNotificationToast, toastify } from "../../helpers/toast/toastify";
import useApi from "../../helpers/apiHelper/requestHelper";
import { useAtom } from "jotai";
import { selectedRowsforVerifyMyTrade, showTableAtom } from "../../store/globalstore";
import { setRefetchSpecificUser } from "../../redux/multicommunity/multicommunity";
import PaymentSuccessModal from "../sharedPages/PaymentSuccessModal";
import LoadingOverlay from "../sharedPages/LoadingOverlay";
import TradesVerifiedInfoModal from "../sharedPages/TradesVerifiedInfoModal";
import SubscribedInfoModal from "../sharedPages/SubscribedInfoModal";
import StoringOnSolanaPlatform from "../sharedPages/StoringOnSolanaPlatform";
import LoadingOverlayModal from "../sharedPages/LoadingOverlayModal";
const VerifyTradePaymentModal = () => {
  const [show, setShow] = useState(true);
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const navigate = useNavigate();
  const location = useLocation();
  const api = useApi();
  const [paymentStaretd, setPaymentStarted] = useState(false);
  const { user } = useSelector((state) => state.user);
  const [showTable, setShowTable] = useAtom(showTableAtom);
  const [loading, setLoading] = useState(false);
  const [verifiedTrade, setisverifiedTrade] = useState(false);
  const [displaySolanaModal, setDisplaySolanaModal] = useState(false);
  const [paymentVerified, setPaymentVerified] = useState(false);
  const paymentTypeForSession = searchParams.get("paymentType");
  const [blockChainLink, setBlockChainLink] = useState("");
  const [blockChainId, setBlockChainId] = useState("");
  const [blockchainApiCalled, setBlockchainApiCalled] = useState(false);
  const [selectedRowsForStatsCalculation, setSelectedRowsForStatsCalculation] =
    useAtom(selectedRowsforVerifyMyTrade);
  const [displayInfoModal, setDisplayInfoModal] = useState(false);
  const [displaySubscribedModal, setdisplaySubscribedModal] = useState(false);
  const subscription = user?.verifiedmyTrade?.subscription;
  const verifyConnected=user?.verifiedmyTrade?.connect;
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext
  );
  // StoringOnSolanaPlatform
  const dispatch = useDispatch();
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const hasActiveSubscription =
    subscription?.active && subscription.originalName;
  const isConnected =
    user?.binanceCredentials?.isConnected ||
    user?.bybitCredentials?.isConnected;
  const handleClose = () => {
    if (onBoardingStartContext) {
      setShow(false);
      dispatch(resetOnBoardingStartContext());
      navigate(onBoardingStartContext, { replace: true });
      return;
    }
    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };
  useEffect(()=>{
    if(!verifyConnected){
      navigate("/leader/verifymyTrade/tradeinfo");
      return;
    }
  },[])
  useEffect(() => {
    const handlePopState = (event) => {
      // Redirect user to desired path when back is clicked
      navigate("/leader/verifiedTrading", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        setLoading(true);
        const response = await api(
          "get",
          `users/verifyTradeCheckoutOneTime?session_id=${sessionId}`
        );

        if (response?.status && response.data.paid) {
          setPaymentVerified(true);
          // BUG: Redux user state was only refreshed inside
          // sendUserDataOnBlockChain (gated behind selectedRowsForStatsCalculation.length > 0),
          // so a one-time payment with no trades selected left the Redux user
          // stale — verifiedmyTrade.payment never flipped and the trader
          // overlay/DOM never updated to reflect the completed payment.
          getUser();
          // Also trigger the app-wide refetch NewLayout listens for, so the
          // sidebar/overlay recompute the same way it does everywhere else
          // in the app instead of relying only on this component's own
          // users/index call.
          dispatch(setRefetchSpecificUser(true));
          // navigate(location.pathname);
          // toastify(
          //   "Verification complete. Find the link in the verified trading links."
          // );
        } else {
          setLoading(false);
          toastify(response.message||"Payment not completed or failed.");
          navigate(location.pathname, { replace: true });
        }
      } catch (error) {
        setLoading(false);
        console.error("Payment check failed:", error);
        toastify(error.message||"Something went wrong");
        navigate(location.pathname, { replace: true });
      }
    };

    if (sessionId && paymentTypeForSession === "onetime") checkPaymentStatus();
  }, [sessionId, location.pathname, paymentTypeForSession]);

  const sendUserDataOnBlockChain = async () => {
    try {
      setBlockchainApiCalled(true);
      
      const response = await api(
        "post",
        "blocakChain/sendSelectedStatsOnBlockChain",
        {
          selectedTrades: selectedRowsForStatsCalculation,
          isLiveTrade: showTable === "live" ? true : false,
        }
      );
      if(!response.status||!response?.data?.blockchainInfo?.statsSentToBlockchain){
        throw response?.data?.blockchainInfo?.message||"Trade verification queued. You'll receive a notification when complete."
      }
      
      setBlockChainLink(response.data.blockchainInfo.blockChainUrl);
      setBlockChainId(response.data.blockchainInfo.blockchainId);
      setSelectedRowsForStatsCalculation([]);
      setLoading(false);
      dispatch(setRefetchSpecificUser(true));
      // if (setRefetchTable) setRefetchTable(true);
      setisverifiedTrade(true);
      return setTimeout(() => {
        setisverifiedTrade(false);
        setDisplaySolanaModal(true);
        setTimeout(()=>{
          setDisplaySolanaModal(false);
          // showNotificationToast("Trade(s) verified!", `Here's the link ${response?.data?.blockchainInfo?.blockChainUrl}`);
          setDisplayInfoModal(true);
          navigate(location.pathname, { replace: true });
        },3000)
        // navigate("/leader/verifymyTrade/tradesVerifiedInfoModal");
      }, 1500);
    } catch (error) {
      setisverifiedTrade(true);
      setTimeout(()=>{
         setSelectedRowsForStatsCalculation([]);
      setLoading(false);
      setisverifiedTrade(false);
      // dispatch(setRefetchSpecificUser(true));
      toastify("Trade verification queued. You'll receive a notification when complete.");
      navigate(location.pathname, { replace: true });
      console.log("Error sending to blockchain:", error);
      },3000)
     
    }
  };
  useEffect(() => {
    const handleBlockchainCall = async () => {
      if (
        paymentVerified &&
        !blockchainApiCalled &&
        selectedRowsForStatsCalculation.length > 0
      ) {
        await sendUserDataOnBlockChain();
      }
    };

    handleBlockchainCall();
  }, [paymentVerified, selectedRowsForStatsCalculation]);

  async function getUser() {
    try {
      const response = await api("get", "users/index");
      if (response?.status) {
        const { data } = response;
        if (dispatch && storeUser) dispatch(storeUser(data));
        // setActiveButton(
        //   data?.user?.verifiedmyTrade?.subscription?.planType === "year" &&
        //     data?.user?.verifiedmyTrade?.subscription?.status === "active"
        //     ? "Yearly"
        //     : "Monthly"
        // );
        if (data?.token) localStorage.setItem("token", data.token);
      }
    } catch (err) {
      console.log(err.message);
    }
  }
  const sendUserDataOnBlockChainPro = async () => {
    try {
      const response=await api("post", "blocakChain/sendSpecificUserStatsOnBlockChain");
      
     
      setisverifiedTrade(true);
      
      // wait 1.5s
      await delay(1500);
      setisverifiedTrade(false);
      if(!response.status){
        throw new Error(response.message);
      }
      setDisplaySolanaModal(true);

      // wait another 3s
      await delay(3000);
      setDisplaySolanaModal(false);
      setdisplaySubscribedModal(true);
      navigate(location.pathname, { replace: true });
      
      // If you want to navigate after showing subscribed modal
      // navigate("/leader/verifymyTrade/subscribedInfoModal");
    } catch (error) {
      console.log("Error sending to blockchain:", error);
      throw error;
    }
  };

  
  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        setLoading(true);
        const response = await api(
          "get",
          `users/verifyTradeCheckoutSubscription?session_id=${sessionId}`
        );

        if (response?.status && response.data.paid) {
          await getUser();
          // BUG: this subscription path never dispatched
          // setRefetchSpecificUser, unlike the one-time trades-selected
          // path (sendUserDataOnBlockChain) — NewLayout's sidebar/overlay
          // refresh (getSpecificUser) never re-ran after a subscription
          // payment, so parts of the DOM stayed stale until a manual reload.
          dispatch(setRefetchSpecificUser(true));
          await sendUserDataOnBlockChainPro();
          // showNotificationToast("Verifying your trades now!", "Your trading is now being verified.You'll get a link each time it's updated on-chain.\n\nUpgrade your subscription for more frequent updates.");
          navigate(location.pathname, { replace: true });
          // toastify("You’re subscribed and performance will be verified.");
          setLoading(false);
        } else {
          setLoading(false);
          toastify(response.message||"Payment not completed or failed.");
          navigate(location.pathname, { replace: true });
        }
      } catch (error) {
        setLoading(false);
        toastify(error.message||"Error while storing performance on blockchain");
        navigate(location.pathname, { replace: true });
        console.error("Payment check failed:", error);
      }
    };

    if (sessionId && paymentTypeForSession === "subscription")
      checkPaymentStatus();
  }, [sessionId]);
 

  return (
    <div className={`onboarding-modal-wrapper`}>
      {(!verifiedTrade &&
      !sessionId &&
      !displayInfoModal &&
      !displaySubscribedModal) && (
        <Modal
          animation={false}
          backdropClassName="onboarding-custom-backdrop"
          centered
          dialogClassName="custom-onboarding-modal verifiedTradingPaymentModal"
          show={show}
        >
          <Modal.Body className={`${paymentStaretd && "bg-white"} figma-drop-shadow`}>
            <button
              className="reverseArrow"
              onClick={() => {
                if (paymentStaretd) {
                  window.location.href = "/leader/verifymyTrade/payment";
                  return;
                }
                // if (hasActiveSubscription && isConnected) {
                //   navigate("/leader/dashboard");
                //   return;
                // } else if (!hasActiveSubscription && isConnected) {
                //   navigate("/leader/verifymyTrade/tradeinfo");
                //   return;
                // }
                navigate("/leader/verifymyTrade/connection", {
                  replace: true,
                });
              }}
              type="button"
            >
              <img alt="" src={longArrow} />
            </button>
            <button className="CrossIcon" onClick={handleClose} type="button">
              <img alt="" src={crossBlack} />
            </button>
            <div className="onboardingContentBox pt-0">
              <VerifyMyTradePayment
                setPaymentStarted={setPaymentStarted}
                paymentType={location?.state?.paymentType}
                showTable={showTable}
                setShowTable={setShowTable}
              />
            </div>
          </Modal.Body>
        </Modal>
      )} 
      {
        // <LoadingOverlay />
        sessionId&&<LoadingOverlayModal/>
      } 
      
      {/* {!verifiedTrade && !sessionId && <LoadingOverlay />} */}
      {verifiedTrade && <PaymentSuccessModal />}
      {displayInfoModal && (
        <TradesVerifiedInfoModal blockChainId={blockChainId} blockChainLink={blockChainLink} setDisplayInfoModal={setDisplayInfoModal} />
      )}
      {displaySubscribedModal && (
        <SubscribedInfoModal
          setdisplaySubscribedModal={setdisplaySubscribedModal}
        />
      )}
      {displaySolanaModal && <StoringOnSolanaPlatform />}
    </div>
  );
};

export default VerifyTradePaymentModal;
